import { render } from "./RenameRoleModal.vue?vue&type=template&id=06ec073e&scoped=true&ts=true"
import script from "./RenameRoleModal.vue?vue&type=script&lang=ts"
export * from "./RenameRoleModal.vue?vue&type=script&lang=ts"

import "./RenameRoleModal.vue?vue&type=style&index=0&id=06ec073e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ec073e"]])

export default __exports__